import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getOutletArr'
})
export class GetOutletArrPipe implements PipeTransform {
  transform(
    items: any[],
    regionSearch: string,
    subRegionSearch: string,
    clusterSearch: string,
    citySearch: string,
    outletSearch: string
  ) {
    if (!items) {
      return '';
    }
    let field;
    let value;
    const arr:any = [];
    if ((regionSearch && regionSearch.length > 0) &&
      (!subRegionSearch || subRegionSearch.length <= 0) &&
      (!clusterSearch || clusterSearch.length <= 0) &&
      (!citySearch || citySearch.length <= 0) &&
      (!outletSearch || outletSearch.length <= 0)) {
      field = 'RegionName';
      value = regionSearch;
    } else if ((subRegionSearch && subRegionSearch.length > 0) &&
      (!clusterSearch || clusterSearch.length <= 0) && (!outletSearch || outletSearch.length <= 0)) {
      field = 'SubRegionName';
      value = subRegionSearch;
    } else if ((clusterSearch && clusterSearch.length > 0) && (!outletSearch || outletSearch.length <= 0)) {
      field = 'ClusterName';
      value = clusterSearch;
    } else if ((citySearch && citySearch.length > 0) && (!outletSearch || outletSearch.length <= 0)) {
      field = 'CityName';
      value = citySearch;
    } else if (outletSearch && outletSearch.length > 0) {
      field = 'OutletCode';
      value = outletSearch;
    } else {
      return arr.toString();
    }
    if (!value) {
      value = [];
    }
    const filteredArr: any = items.filter(it => value.indexOf(it[field]) >= 0);
    // tslint:disable-next-line:forin
    for (const i in filteredArr) {
      if(filteredArr[i].OutletCode){
        arr.push(filteredArr[i].OutletCode);
      }
    }
    return arr.toString();
  }
}
